var SPiD = this.SPiD || {};

(function () {
    'use strict';

    SPiD.canChangeInputType = function () {
        try {
            var input = document.createElement('input');
            input.type = 'password';
            input.type = 'text';
            return true;
        } catch (e) {
            return false;
        }
    };

    function addToggler(container, text) {
        var toggler = document.createElement('a');
        toggler.className = 'reveal-password';
        toggler.innerHTML = text;
        container.appendChild(toggler);
        return toggler;
    }

    function makeRoom(input, toggler) {
        input.style.paddingRight = (10 + toggler.offsetWidth) + 'px';
    }

    function hidePassword(input, toggler, i18n) {
        input.type = 'password';
        toggler.innerHTML = i18n.show;
    }

    SPiD.setupPasswordReveal = function (container, i18n) {
        if (!SPiD.canChangeInputType()) { return; }

        var input = container.getElementsByTagName('input')[0];
        var toggler = addToggler(container, i18n.show);

        makeRoom(input, toggler);

        var toggleType = function () {
            if (input.type === 'password') {
                input.type = 'text';
                toggler.innerHTML = i18n.hide;
            } else {
                hidePassword(input, toggler, i18n);
            }
            makeRoom(input, toggler);
        };

        toggler.addEventListener('click', toggleType);

        input.form.addEventListener('submit', function () {
            hidePassword(input, toggler, i18n);
        });
    };

}());
